import axios from "axios";

const apiUrl = "https://api.mci-server.modus.org";
const providerApiUrl = "https://api.mci-server.modus.org";

export const getDataAPI = async (url) => {
  const TOKEN = `Bearer ${sessionStorage.getItem("loginToken")}`;
  return axios.get(`${apiUrl + url}`, {
    headers: {
      Authorization: TOKEN,
      "Content-Type": "application/json",
    },
  });
};

// post
export const postDataAPI = async (url, post) => {
  const TOKEN = `Bearer ${sessionStorage.getItem("loginToken")}`;
  return axios.post(`${apiUrl + url}`, post, {
    headers: {
      Authorization: TOKEN,
      "Content-Type": "application/json",
    },
  });
};

/**
 * TODO:check the for `/api/${url}`
 */
export const putDataAPI = async (url, post) => {
  const TOKEN = `Bearer ${sessionStorage.getItem("loginToken")}`;
  return axios.put(`${apiUrl + url}`, post, {
    headers: {
      Authorization: TOKEN,
      "Content-Type": "application/json",
    },
  });
};

// update

export const patchDataAPI = async (url, post) => {
  const TOKEN = `Bearer ${sessionStorage.getItem("loginToken")}`;
  return axios.patch(`${apiUrl + url}`, post, {
    headers: {
      Authorization: TOKEN,
      "Content-Type": "application/json",
    },
  });
};

// patch without payload

export const patchWithoutDataAPI = async (url, post) => {
  const TOKEN = `Bearer ${sessionStorage.getItem("loginToken")}`;
  return axios.patch(`${apiUrl + url}`, post, {
    headers: {
      Authorization: TOKEN,
      "Content-Type": "application/json",
    },
  });
};

//deleteData
export const deleteDataAPI = async (url) => {
  const TOKEN = `Bearer ${sessionStorage.getItem("loginToken")}`;
  return axios.delete(`${apiUrl + url}`, {
    headers: {
      Authorization: TOKEN,
      "Content-Type": "application/json",
    },
  });
};

// for provider
export const getProviderDataAPI = async (url) => {
  const TOKEN = `Bearer ${sessionStorage.getItem("loginToken")}`; // this need to be changed, we're keeping it here because this file is gettig loaded even before login hence at global level it's null
  return axios.get(`${providerApiUrl + url}`, {
    headers: {
      Authorization: TOKEN,
      "Content-Type": "application/json",
    },
  });
};

// blob (authenticated binary download, e.g. call recordings)
export const getBlobDataAPI = async (url) => {
  const TOKEN = `Bearer ${sessionStorage.getItem("loginToken")}`;
  return axios.get(`${apiUrl + url}`, {
    headers: {
      Authorization: TOKEN,
    },
    responseType: "blob",
  });
};

// post
export const postProviderDataAPI = async (url, post) => {
  const TOKEN = `Bearer ${sessionStorage.getItem("loginToken")}`;
  return axios.post(`${providerApiUrl + url}`, post, {
    headers: {
      Authorization: TOKEN,
      "Content-Type": "application/json",
    },
  });
};
